module.exports = __webpack_public_path__ + "static/media/clouds.df19b8f4.png";